module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-24.5e315473.png";